<template>
  <form>
    <div
      class="form-group required-field"
      :class="[{ 'has-error': vErrors.first('message'), 'has-success' : !vErrors.first('message') && value['message'] }]"
    >
      <textarea
        id="message"
        v-model="value['message']"
        v-validate="{rules: {required: true, max: 2048}}"
        name="message"
        class="form-control"
        cols="60"
        rows="6"
        required="true"
        :placeholder="$t('pages.taskDetails.comments.modal.inspection.placeholder')"
        :data-vv-as="$t('pages.taskDetails.comments.modal.inspection.dataVvAs')"
      />
      <span
        v-show="vErrors.has('message')"
        class="help-block"
      >{{ vErrors.first('message') }}</span>
    </div>
  </form>
</template>

<script>
import FormModalValidation from '@/components/share/form/FormModalValidation.js'

export default {
  mixins: [
    FormModalValidation
  ],
  props: {
    value: { type: Object, required: true }
  }
}
</script>
